import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';

/**
 * Marks a selected value the inventory has not turned up. Both condition panels let
 * a value be added before discovery finds it, and a selection that matches nothing
 * yet is worth saying out loud rather than leaving to look like any other.
 */
export const NotDiscoveredHint = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography sx={{
      color: "var(--mui-palette-info-main)"
    }}>Not discovered yet</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};